






























import { Mixins } from "vue-mixin-decorator";
import { Component, Prop } from "vue-property-decorator";
import GeneralMixin from "@/mixin";
import { Cost } from "@/models/cost";
import { ICost } from "@/types/cost";

@Component({})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Prop({ default: new Cost() })
  public cost!: ICost;
}
